<template>
    <div class="right_kanban4 common-bg">
        <custom-plane title="道闸数量" :iconImg="require('@/assets/compImg/parking/charge.png')">
            <div class="gate">
                <div class="gate_data">
                    <div class="text">正常数量</div>
                    <div class="numb">
                        {{barrier.normal}}
                    </div>
                </div>
                <div class="gate_data">
                    <div class="text">离线数量</div>
                    <div class="numb abnormal">{{barrier.fault}}</div>
                </div>
            </div>
            <div class="progress">
                <div class="level">
                    <div class="cont">剩余</div>
                    <div class="cont">总量</div>
                </div>
                <div style="width:376px">
                    <custom-progress-heightline :value="value" :splitCount="40"></custom-progress-heightline>
                </div>
            </div>
        </custom-plane>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    props: {
        barrier: Object
    },
    computed: {
        value() {
            return ((Number(this.barrier.normal) /
                Number(this.barrier.total) *
                100))
        },
    },
};
</script>

<style lang="scss" scoped>
.right_kanban4 {
    margin-top: 20px;
    width: 416px;
    height: 185px;

    .gate {
        width: 376px;
        margin: 20px auto;
        align-items: center;
        display: flex;
        justify-content: space-between;
        .text {
            font-weight: 500;
            font-size: 18px;
        }

        .numb {
            width: 63px;
            height: 41px;
            font-weight: 500;
            font-size: 36px;
            font-family: "dina";
        }

        .gate_data {
            display: flex;
            width: 145px;
            height: 41px;
            justify-content: space-between;
            align-items: flex-end;
            text-align: center;
        }
    }

    .progress {
        height: 38px;
        padding: 0 20px;

        .level {
            display: flex;
            justify-content: space-between;
            margin-bottom: 4px;

            .cont {
                font-size: 16px;
                letter-spacing: 0.1em;
            }
        }
    }
}
</style>